import { ModelBase } from '@barthauer/abc/core/data';

export class AsciiWizardTransferObject {
  settingDocument: AsciiWizardSettingDocument;
  fileToUpload: File;
  constructor() {}
}

export interface AsciiWizardSettingDocument {
  id: string;
  name?: string;
}

export class AsciiImportQueryModel extends ModelBase {
  BCEDocumentId?: string;
  ShapezipfileAsBase64?: string;

  constructor() {
    super();
  }
}

export enum FileExtension {
  XLSX = '.xlsx',
  XLS = '.xls',
  XLSM = '.xlsm',
  XLSB = '.xlsb',
  ZIP = '.zip',
}
